import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation, Link } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import BackButton from '../../Shared/BackButton'
import {months_list} from "../../Shared/List";
import { FaEdit } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaFileExport } from "react-icons/fa"

const MonthlyVoucherDetails = () => {
    const [vouchers, setVouchers] = useState([])
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([])
    const [title, setTitle] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
        book: "",
        year: "",
        month: ""
    })
    const {book, year, month} = formData


    const gridRef = useRef();
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {payload} = location.state
            setFormData((prev) => ({
                ...prev,
                year: payload.year,
                month: payload.month,
                book: payload.book
            }))


            fetchData({
                year: payload.year,
                month: payload.month,
                book: payload?.book,
            })
            setTitle(`${payload.book}, ${months_list[payload.month - 1].name} - ${payload.year} Voucher Details`)

        }

    }, [])

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },

        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: true,
        },
        {
            headerName: "ID",
            field: "location_id",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Name",
            field: "full_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Page",
            field: "page",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Due",
            field: "due",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Paid",
            field: "paid",
            sortable: true,
            filter: 'agNumberColumnFilter',
            valueFormatter: params => Number(params.value),
            comparator: (valueA, valueB) => valueA - valueB
        },
        {
            headerName: "Discount",
            field: "discount",
            sortable: true,
            filter: 'agNumberColumnFilter'
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Actions",
            pinned: 'left',
            minWidth: 80,
            sortable: false,
            filter: false,
            cellRenderer: (e) => {
                if (!e.data) return null;
                if (e.node.rowPinned) return '';
                return (
                    <div className="d-flex gap-1">
                        <Link
                            className="btn btn-outline-info"
                            title="Edit voucher"
                            to="/update-voucher"
                            state={{ payload: {
                                year: year,
                                month: month,
                                book: book,
                                page: e.data.page,
                                public_id: e.data.public_id
                            } }}
                        >
                            <FaEdit/>
                        </Link>
                    </div>
                );
            },
        },
    ], [year, month, book]);

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/reports/monthly-voucher-detail/?year=${payload.year}&month=${payload.month}&book=${payload.book}`)
            setVouchers(response?.data)
            setIsLoading(false)

            const output = response?.data.reduce((data, row) => {
                data.due += parseFloat(row.due);
                data.paid += parseFloat(row.paid);
                data.discount += parseFloat(row.discount);
                data.balance += parseFloat(row.balance);
                return data;
            }, {due: 0.00, paid: 0, discount: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    due: parseFloat(output.due).toFixed(2),
                    paid: parseFloat(output.paid).toFixed(0),
                    discount: parseFloat(output.discount).toFixed(2),
                    balance: parseFloat(output.balance).toFixed(2),
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to load voucher details')
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
       <div className="row">
            <div className="col-md-6">
                <BackButton
                    to="/monthly-voucher-summary"
                    state={{ year: location.state?.payload?.year, month: location.state?.payload?.month, by: location.state?.payload?.by }}
                    label="Back to Summary"
                />
            </div>
            <div className="col-md-6">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}

                            rowData={vouchers}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}


                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default MonthlyVoucherDetails